import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-cnae-indicador-badges',
    templateUrl: './cnae-indicador-badges.component.html',
    styleUrls: ['./cnae-indicador-badges.component.less']
})
export class CNAEIndicadorBadgesComponent {
    @Input() principal: boolean;
    @Input() secundaria: boolean;
}
